import Routes from '@common/defs/routes';
import { Box } from '@mui/material';
import { useRouter } from 'next/router';

interface MobileTopbarProps {}
const MobileTopbar = (_props: MobileTopbarProps) => {
  const router = useRouter();
  return (
    <>
      <Box
        sx={{
          mb: 3,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          position: 'sticky',
        }}
      >
        <Box
          component="img"
          src="/images/logos/allo-clients-logo-512.png"
          alt="AlloClients"
          sx={{
            height: 32,
            objectFit: 'contain',
            cursor: 'pointer',
          }}
          onClick={() => router.push(Routes.Common.Home)}
        />
        {/* <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <FeedbackButton size={35} />
          <DiscordButton size={35} />
        </Box> */}
      </Box>
    </>
  );
};

export default MobileTopbar;
